import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { USERROUTES } from 'src/router/Api'
import buildInfo from 'src/build-info.json'
export const getListUser = async (params) => {
	return await axios.get(USERROUTES.name, {
		params: convertParams(params),
	})
}

export interface CmsUserListParams {
	page: number
	limit: number
	search_field?: string
	search_key?: string
	location_field?: 'country' | 'province'
	location_key?: string
	status?: string
}

/**
 * CMS-only list endpoint. It deliberately does not accept generic `fields` or
 * `where` parameters, so the User table cannot accidentally request every
 * user relation again.
 */
export const getCmsUserList = async (
	params: CmsUserListParams,
	signal?: AbortSignal,
) => {
	return await axios.get(`${USERROUTES.name}/cms-list`, {
		params,
		signal,
	})
}

export const runScriptStream = async (endpoint: string, onMessage) => {
	const accessToken = localStorage.getItem('token')
	let parsedToken: string
	try {
		parsedToken = JSON.parse(accessToken)
	} catch {
		parsedToken = accessToken
	}

	const response = await fetch(`${process.env.REACT_APP_API_URL}/${endpoint}`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${parsedToken}`,
			Accept: 'text/event-stream',
			Platform: 'CMS',
			Version: `${buildInfo.version || ''}`,
		},
	})

	if (!response.ok || !response.body) {
		throw new Error('Run script failed')
	}

	const reader = response.body.getReader()
	const decoder = new TextDecoder()
	let buffer = ''

	while (true) {
		const { done, value } = await reader.read()
		if (done) break

		buffer += decoder.decode(value, { stream: true })
		const events = buffer.split('\n\n')
		buffer = events.pop() || ''

		events.forEach((eventText) => {
			const eventName = eventText
				.split('\n')
				.find((line) => line.startsWith('event: '))
				?.replace('event: ', '')
			const dataLine = eventText
				.split('\n')
				.find((line) => line.startsWith('data: '))

			if (!dataLine) return
			onMessage({
				event: eventName,
				data: JSON.parse(dataLine.replace('data: ', '')),
			})
		})
	}
}

export const syncAddressLocalForSearchInApp = async (onMessage) => {
	try {
		await runScriptStream(
			`${USERROUTES.name}/sync-address-local-for-search-in-app`,
			onMessage,
		)
	} catch (error) {
		if (error?.message === 'Run script failed') {
			throw new Error('Sync location failed')
		}
		throw error
	}
}

export const syncCountryForSearchInApp = async (onMessage) => {
	try {
		await runScriptStream(
			`${USERROUTES.name}/sync-country-for-search-in-app`,
			onMessage,
		)
	} catch (error) {
		if (error?.message === 'Run script failed') {
			throw new Error('Sync country failed')
		}
		throw error
	}
}
export const getOneUser = async (id, params) => {
	return await axios.get(`${USERROUTES.name}/${id}`, {
		params: convertParams(params),
	})
}
export const createGuider = async (payload) => {
	return await axios.post(USERROUTES.name, payload)
}

export const updateUser = async (id, payload) => {
	return await axios.put(`${USERROUTES.name}/${id}`, payload)
}

export const forceUpdateUserPosition = async (id, payload) => {
	return await axios.put(`${USERROUTES.name}/${id}/force-position`, payload)
}

export const searchGooglePlace = async (payload) => {
	return await axios.post('map/google/place/textsearch/json', payload)
}


export const blockUserTemp = async (payload) => {
	return await axios.post(`${USERROUTES.name}/block-by-admin`, payload)
}

export const unBlockUserTemp = async (payload) => {
	return await axios.post(`${USERROUTES.name}/unblock-by-admin`, payload)
}

export const getUserDevices = async (id, params) => {
	return await axios.get(`${USERROUTES.device}/${id}`, {
		params: convertParams(params),
	})
}
export const deleteUser = async (id) => {
	return await axios.delete(`${USERROUTES.name}/${id}`)
}

export const setVerifyUser = async (id: string, is_verified: boolean) => {
	return await axios.put(`${USERROUTES.name}/${id}`, { is_verified })
}

export const setVerifyRegularUser = async (id: string, is_regular: boolean) => {
	return await axios.put(`${USERROUTES.name}/${id}`, { is_regular })
}

export const supportCreateAccount = async (payload) => {
	return await axios.post(USERROUTES.support_create_account, payload)
}
